<script>
import { ref } from 'vue';
import InboxesAPI from 'dashboard/api/inboxes';
import { useAlert } from 'dashboard/composables';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: { NextButton },
  props: {
    inbox: { type: Object, required: true },
  },
  emits: ['inbox-refresh'],
  setup() {
    const isActivating = ref(false);
    return { isActivating };
  },
  methods: {
    async activate() {
      if (!this.inbox?.id) return;
      this.isActivating = true;
      try {
        const { data } = await InboxesAPI.setupVkCallback(this.inbox.id);
        if (data?.ok) {
          useAlert(this.$t('INBOX_MGMT.ADD.VK_CALLBACK.ACTIVATED'));
          this.$emit('inbox-refresh');
        } else {
          useAlert(data?.error || this.$t('INBOX_MGMT.ADD.VK_CHANNEL.CREATE_ERROR'));
        }
      } catch (e) {
        const msg = e?.response?.data?.error || e?.message || this.$t('INBOX_MGMT.ADD.VK_CHANNEL.CREATE_ERROR');
        useAlert(msg);
      } finally {
        this.isActivating = false;
      }
    },
  },
};
</script>

<template>
  <div v-if="!inbox.vk_callback_configured" class="mb-4 flex items-center gap-3 rounded-lg border border-n-slate-6 bg-n-slate-2 p-4">
    <span class="text-sm text-n-slate-11">{{ $t('INBOX_MGMT.ADD.VK_CALLBACK.NOT_ACTIVATED') }}</span>
    <NextButton
      :is-loading="isActivating"
      type="button"
      solid
      blue
      :label="$t('INBOX_MGMT.ADD.VK_CALLBACK.ACTIVATE_BUTTON')"
      @click="activate"
    />
  </div>
  <div v-else class="mb-4 rounded-lg border border-n-slate-6 bg-n-slate-2 p-4">
    <span class="text-sm text-n-green-11">{{ $t('INBOX_MGMT.ADD.VK_CALLBACK.ACTIVE') }}</span>
  </div>
</template>
